export const Screen = {
  xs: 400,
  sm: 600,
  md: 768,
  lg: 1024,
  xl: 1280,
};

export const Grid = {
  gutterWidth: 24,
  outerMargin: 0,
  maxWidth: 1280,
  totalCols: 12,
};

export default { screen: Screen, grid: Grid };
